import React from 'react';
import { NavLink } from 'react-router-dom';
import { format } from 'timeago.js';
import { getPhotoUrl, handlePrice } from '../../shared/util/MiscUtil'
import noPhoto from '../../assets/images/no-photo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconsLibrary } from "../../shared/util/FontAwesomeIconsUtil";
import { LazyLoadImage } from "react-lazy-load-image-component";
import sortBy from 'lodash.sortby';

function ListingGridBox(props) {

    const [imageLoadError, setImageLoadError] = React.useState(false);
    const { listing } = props;
    const listingUrl = !!listing ? "/" + listing.slug + "/oglas/" + listing.id : "/";

    const photos = !!listing && !!listing.photos && sortBy(listing.photos, ["order", "id"]);

    return (
        <div className="flex w-1/2 xs:w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 mb-2 px-1 overflow-hidden">
            <NavLink title={listing.title} className="w-full" to={listingUrl}>
                <div className={"flex flex-col w-full justify-between h-full cursor-pointer transition rounded-lg p-2 bg-gray-lightest hover:bg-gray-lighter"}>
                    <div className="h-48 w-full">
                        {!!listing.isBoosted && (
                            <span className="absolute">
                                <FontAwesomeIcon icon={IconsLibrary.faStar} className="text-yellow text-xl m-2 mr-5" />
                            </span>
                        )}
                        {!listing.discountActive && !!photos[0] && (
                            <LazyLoadImage 
                            onError={(error) => {
                                if (!!error) {
                                    setImageLoadError(true);
                                } else setImageLoadError(false);
                            }}
                            className="object-contain h-48 w-full rounded-md bg-white" alt={listing.title} src={!imageLoadError ? getPhotoUrl(listing.id, photos[0].fileName) : noPhoto} width={218} height={192} />
                        )}
                        {!!listing.discountActive && !!photos[0] && (
                            <div className="relative">
                            <LazyLoadImage 
                            onError={(error) => {
                                if (!!error) {
                                    setImageLoadError(true);
                                } else setImageLoadError(false);
                            }}
                            className="object-contain h-48 w-full rounded-md bg-white" alt={listing.title} src={!imageLoadError ? getPhotoUrl(listing.id, photos[0].fileName) : noPhoto} width={218} height={192} />
                            <div className="bg-purple text-white w-14 text-center font-semibold top-0 rounded-md absolute">
                                -{listing.discount}<span className="text-sm">%</span>
                            </div>
                            {!!listing.isBoosted && <FontAwesomeIcon icon={IconsLibrary.faStar} className="absolute text-yellow text-xl top-0 right-0 m-2" />}
                            </div>
                        )}
                        {!listing.discountActive && (!photos || (!!photos && photos.length === 0)) && (
                            <LazyLoadImage className="object-contain h-48 w-full rounded-md bg-white" alt={listing.title} src={noPhoto} width={218} height={192} />
                        )}
                        {!!listing.discountActive && (!photos || (!!photos && photos.length === 0)) && (
                            <div className="relative">
                            <LazyLoadImage className="object-contain h-48 w-full rounded-md bg-white" alt={listing.title} src={noPhoto} width={218} height={192} />
                            <div className="bg-purple text-white w-14 text-center font-semibold top-0 rounded-md absolute">
                                -{listing.discount}<span className="text-sm">%</span>
                            </div>
                            {!!listing.isBoosted && <FontAwesomeIcon icon={IconsLibrary.faStar} className="absolute text-yellow text-xl top-0 right-0 m-2" />}
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col pt-3 h-full justify-between space-y-3">
                        {!!listing.title && listing.title.length > 40 && (
                        <div className="text-gray-darkest font-semibold leading-4">
                            <span className="leading-4" dangerouslySetInnerHTML={{ __html: listing.title.replace(/(<([^>]+)>|(&#xfeff;)|(&#34;))/gi, " ").substring(0, 40) + "..."}} />
                        </div>
                        )}
                        {!!listing.title && listing.title.length <= 25 && (
                        <div className="text-gray-darkest font-semibold leading-4">
                            <span className="leading-4" dangerouslySetInnerHTML={{ __html: listing.title.replace(/(<([^>]+)>|(&#xfeff;)|(&#34;))/gi, " ")}} />
                        </div>
                        )}
                        {!!listing.title && listing.title.length > 25 && listing.title.length <= 40 && (
                        <div className="text-gray-darkest font-semibold leading-4">
                            <span className="leading-4" dangerouslySetInnerHTML={{ __html: listing.title.replace(/(<([^>]+)>|(&#xfeff;)|(&#34;))/gi, " ").substring(0, 40) + "..."}} />
                        </div>
                        )}
                        {/* {!!listing.title && listing.title.length <= 62 && (
                            <div className="text-gray-darkest font-semibold leading-7">
                            <span className="leading-7" dangerouslySetInnerHTML={{ __html: listing.title.substring(0, 62)}} />
                        </div>
                        )} */}
                        <div className="flex flex-wrap sm:flex-nowrap justify-between items-center text-sm">
                            {!listing.discountActive && !listing.askForPrice && (!!listing.price || listing.price === 0) && (
                                <div className="whitespace-nowrap py-1 px-2 rounded bg-purple text-white font-bold tracking-wider">{handlePrice(listing.price)}</div>
                            )}
                            {!!listing.discountActive && (
                                <div className="whitespace-nowrap py-1 px-2 rounded bg-purple text-white font-bold tracking-wider">
                                    <FontAwesomeIcon icon={IconsLibrary.faFire} className="text-yellow mr-2" />
                                    {handlePrice(listing.price)}
                                </div>
                            )}
                            {!!listing.askForPrice && (
                                <div className="py-1 px-2 rounded bg-purple text-white font-bold tracking-wider">{listing.askForPrice}</div>
                            )}
                            {!!listing.publishSorted && <div className="font-semibold text-xs text-gray-dark px-0 sm:px-2 pt-1 sm:pt-0">{format(listing.publishSorted, 'bs_BA')}</div>}
                        </div>
                    </div>
                </div>
            </NavLink>
        </div>
    );
}

export default ListingGridBox;
